import { combineReducers } from 'redux';

import { reducer as afficheNewsState } from '../afficheNews/store';

const homePageReducer = combineReducers({
    afficheNewsState
});

export default homePageReducer;


// WEBPACK FOOTER //
// ./src/components/homePage/store/index.js